// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__2Tf2S","image":"App_image__YXyQx"};